import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'jhi-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss']
})
export class ConfirmationComponent {

  constructor(private router: Router) { }

  goToHome() {
    this.router.navigate(['/']);
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/steps/confirmation/confirmation.component.ts